import mgr from '@/app/globals'

export default mgr;